import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { LogoLockup } from "./Logo";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/funding", label: "Funding Solutions" },
    { to: "/lenders", label: "Lenders" },
    { to: "/iso-partners", label: "ISO Partners" },
    { to: "/how-it-works", label: "How It Works" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const loc = useLocation();
    React.useEffect(() => { setOpen(false); }, [loc.pathname]);

    return (
        <header
            className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-black/5"
            data-testid="site-header"
        >
            <div className="container-lended flex items-center justify-between h-20">
                <Link to="/" className="flex items-center" data-testid="header-logo-link">
                    <LogoLockup size={40} />
                </Link>

                <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `text-sm font-medium transition-colors hover:text-[#FF6B1A] ${
                                    isActive ? "text-[#FF6B1A]" : "text-black/80"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <Link to="/apply" className="btn-orange text-sm" data-testid="header-apply-cta">
                        Apply Now
                    </Link>
                </div>

                <button
                    className="lg:hidden p-2 text-black"
                    onClick={() => setOpen(!open)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden border-t border-black/10 bg-white" data-testid="mobile-nav">
                    <div className="container-lended py-6 flex flex-col gap-4">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) =>
                                    `text-base font-medium ${isActive ? "text-[#FF6B1A]" : "text-black/85"}`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                        <NavLink
                            to="/apply"
                            data-testid="mobile-nav-full-application"
                            className={({ isActive }) =>
                                `text-base font-medium ${isActive ? "text-[#FF6B1A]" : "text-black/85"}`
                            }
                        >
                            Full Application
                        </NavLink>
                        <Link to="/apply" className="btn-orange text-sm justify-center" data-testid="mobile-apply-cta">
                            Apply Now
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
